const vibrantColors = [
  'f43f5e',
  'f97316',
  'fb923c',
  'facc15',
  '84cc16',
  '22c55e',
  '14b8a6',
  '0ea5e9',
  '38bdf8',
  '6366f1',
  '8b5cf6',
  'a855f7',
  'd946ef',
  'ec4899',
  'e879f9',
  'f472b6',
  'eab308',
  'fde047',
];

const fallbackColorPairs = [
  { from: '#006AFF', to: '#47F607' },
  { from: '#781DE8', to: '#006AFF' },
  { from: '#FF6E00', to: '#781DE8' },
  { from: '#35B805', to: '#0EA5E9' },
  { from: '#D946EF', to: '#F97316' },
  { from: '#14B8A6', to: '#6366F1' },
];

const getUserAvatarHash = (userId: number) =>
  String(userId)
    .split('')
    .reduce((acc, char) => acc + char.charCodeAt(0), 0);

export const getUserAvatarUrl = (userId: number) => {
  const hash = getUserAvatarHash(userId);
  const color = vibrantColors[hash % vibrantColors.length];

  const seed = encodeURIComponent(userId);

  return `https://api.dicebear.com/8.x/thumbs/svg?seed=${seed}&backgroundType=gradientLinear&backgroundColor=${color}&scale=85`;
};

export const getUserAvatarFallbackColors = (userId: number) => {
  const hash = getUserAvatarHash(userId);

  return fallbackColorPairs[hash % fallbackColorPairs.length];
};
